module.exports = __webpack_public_path__ + "img/con4.963a185a.png";